
import { useLazyGetEventInsightsQuery } from '@/services/eventApi';
import { Tooltip, Skeleton } from '@mui/material';

const VenueDataCell = ({ bteId, venue }) => {
  
  const [getEventInsights, { data, isLoading }] = useLazyGetEventInsightsQuery();
  
  const SeatingCapacityData = async () => {
    try {
      if (!data) {
        await getEventInsights(bteId);
      }
    } catch (error) {
      console.error("Error: ", error);
    }
  };
    
  return (
    <Tooltip
      title={
        <span>
          {venue?.name}, {venue?.city} <br/>
          Seating Capacity: {isLoading ? <Skeleton variant="text" width={25} style={{display: 'inline-block'}} /> : data?.venueCapacity ?? "n/a"}
        </span>}
      onOpen={SeatingCapacityData}
    >
      <div>{`${venue?.name}, ${venue?.city}`}</div>
    </Tooltip>
  );

};

export default VenueDataCell;